import { render, staticRenderFns } from "./CNBankForm.vue?vue&type=template&id=8fae58c0&scoped=true&"
import script from "./CNBankForm.vue?vue&type=script&lang=js&"
export * from "./CNBankForm.vue?vue&type=script&lang=js&"
import style0 from "./CNBankForm.vue?vue&type=style&index=0&id=8fae58c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fae58c0",
  null
  
)

export default component.exports